var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable, inject } from 'tsyringe';
import firebase from 'firebase/app';
import { Output } from '../dto';
let ImoryApiDataSource = class ImoryApiDataSource {
    constructor(functions = firebase.app().functions('asia-northeast1')) {
        this.functions = functions;
        this.rootCallable = 'v1-callable';
    }
    /**
     * クリニック新規登録を申請する
     */
    async applyClinic(clinic) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-account-apply`);
        await callable(clinic.data());
    }
    /**
     * クリニック新規登録申込を承認する
     */
    async approvalClinic(applyId) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-account-approval`);
        const result = await callable({ applyId });
        return new Output.ApprovalClinic(result.data);
    }
    /**
     * 決済アカウントを登録（クレジットカード決済、銀行口座）
     */
    async registerAccount(paymentMethod, creditCardToken) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-registerAccount`);
        await callable({ paymentMethod, creditCardToken });
    }
    /**
     * クレジットカード情報を取得
     */
    async loadCreditCard() {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-loadCreditCard`);
        const result = await callable();
        return new Output.Response(result.data);
    }
    /**
     * 課金プラン登録（新規登録、更新含む）
     */
    async registerPlan(planType, paymentMethod, idempotencyKey) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-registerPlan`);
        await callable({ planType, paymentMethod, idempotencyKey });
    }
    /**
     * クーポンの登録
     */
    async registerCoupon(couponId) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-registerCoupon`);
        await callable({ couponId });
    }
    /**
     * 課金プランの解約
     */
    async cancelPlan(idempotencyKey) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-cancelPlan`);
        await callable({ idempotencyKey });
    }
    /**
     * 求人情報を作成
     */
    async saveJobOffer(dto) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-job_offer-saveJobOffer`);
        const result = await callable(dto);
        return new Output.Response(result.data);
    }
    /**
     * 求人情報を登録
     */
    async registerJobOffer(dto) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-job_offer-registerJobOffer`);
        await callable(dto);
    }
    /**
     * 募集中状態を変更（募集中・募集を止める）
     */
    async updateRecruitment(jobOfferId, value) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-job_offer-updateRecruitment`);
        await callable({ jobOfferId, value });
    }
    /**
     * 求人応募申込の承認・未承認
     */
    async approvalJobApplied(workerId, jobOfferId, isApprove) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-job-approvalJobApplied`);
        await callable({ workerId, jobOfferId, isApprove });
    }
    /**
     * Stripeメールアドレスを更新する
     */
    async updateStripeEmail(email) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-clinic_account-updateStripeEmail`);
        await callable({ email });
    }
    /**
     * 領収書一覧を取得
     */
    async loadReceipts(limit, startingAfterId) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-receipt-loadClinicReceipts`);
        const result = await callable({ limit, startingAfterId });
        return new Output.Response(result.data);
    }
    /**
     * 修正申請の許可
     */
    async approvalCorrectReward(modificationRequestId, isApprove, amount) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-pay_reward-approvalCorrectReward`);
        await callable({ modificationRequestId, isApprove, amount });
    }
    /**
     * ワーカーへの支払い
     */
    async payRewardToWorker(rewardId, amount) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-pay_reward-payRewardToWorker`);
        await callable({ rewardId, amount });
    }
    /**
     * ワーカーのレビューを投稿
     */
    async postReviewFromClinic(rating, text, jobOfferId, workerId) {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-review-postReviewFromClinic`);
        await callable({ rating, text, jobOfferId, workerId });
    }
    /**
     * クリニックの定期購入プランの契約状態を取得する
     */
    async loadContractRenewal() {
        const callable = this.functions.httpsCallable(`${this.rootCallable}-billing-loadContractRenewal`);
        const result = await callable();
        return new Output.Response(result.data);
    }
};
ImoryApiDataSource = __decorate([
    injectable(),
    __param(0, inject('Functions')),
    __metadata("design:paramtypes", [firebase.functions.Functions])
], ImoryApiDataSource);
export { ImoryApiDataSource };
